import { useQuery, gql } from '@apollo/client'
import Organization from '@/gf/modules/Organization'

const query = gql`
  query CustomerOrganization($id: String!) {
    customerOrganization(id: $id) {
      id
      name
      phoneNumber
      openOrdersCount
      closedOrdersCount
      lastActivityDate
    }
  }
`

const useOrganization = (variables) => {
  const result = useQuery(query, { variables, fetchPolicy: 'no-cache' })

  const data = result.data && {
    ...result.data,
    customerOrganization: {
      ...Organization.fromPayload(result.data.customerOrganization),
    },
  }

  return { ...result, data }
}

export default useOrganization
